import companyStoreGetters from '@constans/store/company/companyStoreGetters';
const getters = {
    [companyStoreGetters.GET_BORDER]: (state) => state.borders,
    [companyStoreGetters.LIST_TENANTS]: (state) => state.tenants,
    [companyStoreGetters.LIST_ACTIVE_TENANTS]: (state) => state.tenants.filter(tenant => tenant.state == 1),
    [companyStoreGetters.GET_VIEWINGS]: (state) => state.viewings.list
};
export default getters;
